import { render, staticRenderFns } from "./BasicFilter.vue?vue&type=template&id=3facfd28&"
import script from "./BasicFilter.vue?vue&type=script&lang=js&"
export * from "./BasicFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports